export default __webpack_public_path__ + "static/media/soldout1.00c41592.png";